import React from 'react';

const COLORS = [
  ['#3b82f6','#1e3a5f'], ['#8b5cf6','#2e1065'], ['#10b981','#064e3b'],
  ['#f59e0b','#451a03'], ['#ef4444','#450a0a'], ['#06b6d4','#083344'],
];

function colorFromName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar({ user, size = 48, style = {} }) {
  const name = user?.name || '?';
  const initials = name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
  const [fg, bg] = colorFromName(name);

  if (user?.photo) {
    return (
      <img
        src={user.photo}
        alt={name}
        style={{
          width: size, height: size, borderRadius: '50%',
          objectFit: 'cover', flexShrink: 0, ...style,
        }}
      />
    );
  }

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: bg, color: fg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.38, fontWeight: 700,
      flexShrink: 0, userSelect: 'none', ...style,
    }}>
      {initials}
    </div>
  );
}
